import React, { FunctionComponent, useEffect } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'

import { Websites } from '../../components/pages/old'

import { getWebsites, addWebsite } from '../../actions/websites'

import { State } from '../../reducers'
import { Website, WebsitesStore } from '../../typings/website'

interface WebsitesProps extends RouteComponentProps {
  basePath: string
  websites?: WebsitesStore
  showAddForm?: boolean
  activeWebsite: Website
  getWebsites(): void
  addWebsite(): void
}

const WebsitesContainer: FunctionComponent<WebsitesProps> = ({
  history,
  basePath,
  websites,
  showAddForm,
  activeWebsite,
  getWebsites,
  addWebsite,
}) => {
  useEffect(() => {
    getWebsites()
  }, [getWebsites, activeWebsite])

  return (
    <Websites
      basePath={basePath}
      websites={websites}
      showAddForm={showAddForm}
      closeAdd={() => {
        history.push(basePath)
        getWebsites()
      }}
      addWebsite={addWebsite}
    />
  )
}

const mapStateToProps = (state: State) => ({
  websites: state.websites,
  activeWebsite: state.user.activeWebsite,
})

const mapDispatchToProps = dispatch => ({
  getWebsites: () => dispatch(getWebsites()),
  addWebsite: (w: Website) => dispatch(addWebsite(w)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WebsitesContainer)
)
